// @flow
export { default } from './ProductComment';



// WEBPACK FOOTER //
// ./src/components/product/ProductComment/index.js